export default "__VITE_ASSET__V7liSFc0__"